export const TAB_BADGE_STYLE = {
    minWidth: '3rem',
} as const;

export const TAB_BADGE_ACTIVE_STYLE = {
    ...TAB_BADGE_STYLE,
    background: 'hsl(48 100% 80% / 1)',
    color: 'hsl(0deg 0% 0%)',
} as const;

export const TAB_BADGE_ZERO_STYLE = {
    ...TAB_BADGE_STYLE,
    background: '#f3f4f6',
    color: '#9ca3af',
} as const;

// Orange, not the active yellow: the count is a minimum because some sources could not be loaded.
export const TAB_BADGE_PARTIAL_STYLE = {
    ...TAB_BADGE_STYLE,
    background: '#fed7aa',
    color: TAB_BADGE_ACTIVE_STYLE.color,
} as const;

export const getTabBadgeStyle = (count: number) =>
    count > 0 ? TAB_BADGE_ACTIVE_STYLE : TAB_BADGE_ZERO_STYLE;

export const CONDITIONS_BADGE_STYLE = TAB_BADGE_ACTIVE_STYLE;
